import React, { useState, useEffect } from 'react';
import HeadingArea from '../../general/HeadingArea';
import { AiOutlineSearch } from 'react-icons/ai';
import { HiSearch } from 'react-icons/hi';
import { FaUserEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import ResponseMsg2 from '../../general/ResponseMsg2';
import { Bs1CircleFill, Bs2CircleFill } from 'react-icons/bs';
import UserLogo from '../../assets/user-logo.png';
import NoDataFound from '../../assets/no-data.png';


const AllStudents = ({ setLoading }) => {
  const [classes, setClasses] = useState([]);
  const [std, setStd] = useState([]);
  const [availableSections, setAvailableSections] = useState([]);
  const [selectedClassId, setSelectedClassId] = useState('');
  const [selectedSection, setSelectedSection] = useState('');
  const [academicYears, setAcademicYears] = useState([]);
  const [selectedAY, setSelectedAY] = useState('');
  const navigate = useNavigate();
  const [selectedStd, setSelectedStd] = useState('');
  const [showStd, setShowStd] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
    const [response2, setResponse2] = useState({ message: '', status: 'success' });
  const [feeStr, setFeeStr] = useState([]);
const [searchTerm, setSearchTerm] = useState('');
const [selectedStudents, setSelectedStudents] = useState([]);
const [showPromote, setShowPromote] = useState(false);
const [promoteClassId, setPromoteClassId] = useState('');
const [promoteSection, setPromoteSection] = useState('');
const [promoteAY, setPromoteAY] = useState('');
const [myAtd, setMyAtd] = useState([]);


  const fetchClasses = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-classes');
      if (response.ok) {
        const data = await response.json();
        setClasses(data);
      } else {
        console.error('Failed to fetch class');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };

  const fetchAcademicYears = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-academic-years');
      if (response.ok) {
        const data = await response.json();
        setAcademicYears(data);
      } else {
        console.error('Failed to fetch academic years');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };


    const fetchStdAtd = async () => {
    setLoading(true);
    try {

      const response = await fetch(`https://api.kcian.in/get-myatd-report/${selectedStd.id}`);
      if (response.ok) {
        const data = await response.json();
        setMyAtd(data);
      } else {
        console.error('Failed to fetch class');
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false);
    }
  };


  const attendanceSummary = myAtd.reduce(
  (acc, item) => {
    const mark = (item.mark || '').toLowerCase();

    if (mark === 'present') acc.present += 1;
    else if (mark === 'absent') acc.absent += 1;
    else if (mark === 'leave') acc.leave += 1;

    return acc;
  },
  { present: 0, absent: 0, leave: 0 }
);

  // Initial fetches for classes and academic years
  useEffect(() => {
    fetchClasses();
    fetchAcademicYears();
     const currentAY = new Date().getFullYear();

       if (currentAY) {
        setSelectedAY(currentAY);
        fetchStudents(currentAY);
      }
  }, []);
  

      const fetchFeeStr = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://api.kcian.in/get-fee-structure');
      if (response.ok) {
        const data = await response.json();
const filteredData = data.filter(item => {
  try {
    const classInfo = JSON.parse(item.class_id);
    return classInfo.classId == selectedClassId;
  } catch (e) {
    return false;
  }
});
        setFeeStr(filteredData);
      } else {
        console.error('Failed to fetch particulars');
      }
    } catch (error) {
      console.error('Error fetching particulars:', error);
    }
    setLoading(false);
  };


  useEffect(() => {
    if (selectedClassId) {
      const selectedClass = classes.find((cls) => cls.id === Number(selectedClassId));
      if (selectedClass && selectedClass.sections) {
        const sectionArray = selectedClass.sections
          .split(',')
          .map((s) => s.trim())
          .filter((s) => s !== '');
        setAvailableSections(sectionArray);
      } else {
        setAvailableSections([]);
      }
      setSelectedSection('');
    } else {
      setAvailableSections([]);
      setSelectedSection('');
    }
  }, [selectedClassId, classes]);

  // New: Search function to fetch filtered students
  const handleSearch = async (e) => {
    e.preventDefault();

    if (!selectedAY || !selectedClassId) {
      alert('Please select both Academic Year and Class to search.');
      return;
    }
    
     fetchStudents(selectedAY, selectedClassId, selectedSection);
  };


   const fetchStudents = async (ay, classId, section = '') => {
    setLoading(true);
    try {
      const selectedClass = classes.find((cls) => cls.id === Number(classId));
      const className = selectedClass ? selectedClass.class_name : '';

      const params = new URLSearchParams();
      params.append('ay', ay);
      params.append('class_name', className);
      if (section) params.append('section', section);

      const url = `https://api.kcian.in/get-student?${params.toString()}`;
      const response = await fetch(url);

      if (response.ok) {
        const data = await response.json();
        setStd(data);
      } else {
        console.error('Failed to fetch students');
      }
    } catch (error) {
      console.error('Error fetching students:', error);
    } finally {
      setLoading(false);
    }
  };


            const handleShowView = async (std) => {
              fetchFeeStr();
         await     fetchStdAtd();
    setSelectedStd(std);
    setShowStd(true);
  }


          const handleShowDelete = (std) => {
    setSelectedStd(std);
    setShowDelete(true);
  }
 

                const handleDelete = async (stdId) => {
    try {
      const response = await fetch(`https://api.kcian.in/remove-student/${stdId}`, {
        method: 'DELETE',
      });


      if (response.ok) {
setStd((prevData) => prevData.filter((product) => product.id !== stdId));
        setShowDelete(false);
        setResponse2({ message: 'Student Removed successfully!', status: 'success' });
        setTimeout(() => {
          setResponse2('');
        }, 2000);
      } else {
                setResponse2({ message: 'Something Went Wrong. Please try again.', status: 'error' });
        setTimeout(() => {
          setResponse2('');
        }, 2000);   
      }
    } catch (error) {
      console.error('Error deleting Student:', error);
    }
  };

const filteredStd = std.filter(student => {
  const term = searchTerm.toLowerCase();
  const name = student.name ? student.name.toLowerCase() : '';
  const regNo = student.reg_no ? student.reg_no.toLowerCase() : '';
  return name.includes(term) || regNo.includes(term);
});


const handleStudentSelect = (student) => {
  setSelectedStudents((prev) => {
    const exists = prev.some((s) => s.id === student.id);

    if (exists) {
      return prev.filter((s) => s.id !== student.id);
    }

    return [...prev, student];
  });
};


const handlePromoteStudents = async () => {
  if (!promoteAY || !promoteClassId || !promoteSection) {
    setResponse2({
      message: 'Please select Class and Section',
      status: 'error'
    });
     setTimeout(() => {
          setResponse2('');
        }, 2000);   
    return;
  }

  try {
    setLoading(true);

       const studentsToPromote = selectedStudents;


    const selectedClass = classes.find(
  cls => cls.id === Number(promoteClassId)
);

const class_name = selectedClass?.class_name || '';

    const response = await fetch(
      'https://api.kcian.in/promote-students',
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          students: studentsToPromote,
          year: promoteAY,
          class_name: class_name,
          section: promoteSection
        })
      }
    );

    const result = await response.json();

    if (response.ok) {
      setResponse2({
        message: 'Students promoted successfully',
        status: 'success'
      });

      setSelectedStudents([]);
      await fetchStudents(selectedAY, selectedClassId, selectedSection);
      setShowPromote(false);
    } else {
      setResponse2({
        message: result.message || 'Promotion failed',
        status: 'error'
      });
    }
  } catch (error) {
    console.error(error);

    setResponse2({
      message: 'Something went wrong',
      status: 'error'
    });
  } finally {
    setLoading(false);
     setTimeout(() => {
          setResponse2('');
        }, 2000);   
  }
};

  return (
    <>
      <section className='py-4'>
        <div className='px-4'>
          <HeadingArea message1='Student' message2='All Students' />

          <form onSubmit={handleSearch} className='profile-card'>
            <span className="profile-heading">Select Criteria</span>

            <div className='d-md-flex d-sm-flex d-block mt-3'>
              <div className="mb-4 w-100 me-3">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select AY*</label>
                  <select
                    className="profile-input"
                    value={selectedAY}
                    onChange={(e) => setSelectedAY(e.target.value)}
                    required
                  >
                    <option value="">-- Select Academic Year --</option>
                    {academicYears.map((ay) => (
                      <option key={ay.year} value={ay.year}>
                        {ay.year} --- {ay.title}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mb-4 w-100 me-3">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select Class*</label>
                  <select
                    className="profile-input"
                    value={selectedClassId}
                    onChange={(e) => setSelectedClassId(e.target.value)}
                    required
                  >
                    <option value="">-- Select Class --</option>
                    {classes.map((cls) => (
                      <option key={cls.id} value={cls.id}>
                        {cls.class_name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>

              <div className="mb-4 w-100">
                <div className='profile-input-area'>
                  <label className="profile-badge">Select Section*</label>
                  <select
                    className="profile-input"
                    value={selectedSection}
                    onChange={(e) => setSelectedSection(e.target.value)}
                    disabled={availableSections.length === 0}
                  >
                    <option value="">-- Select Section --</option>
                    {availableSections.map((section, idx) => (
                      <option key={idx} value={section}>
                        {section}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>

            <div className='text-end'>
              <button type='submit' className='profile-btn2'>
                <AiOutlineSearch /> Search
              </button>
            </div>
          </form>

          <div className='profile-card mt-4'>

            <div className='d-md-flex d-sm-flex justify-content-between'>
            <span className="profile-heading align-content-center">Student List</span>

                              <div className='profile-input-area ms-auto col-lg-3 border-0'>
<input
  type='text'
  name='search'
  className='profile-input border-bottom rounded-0'
  placeholder='Search...'
  value={searchTerm}
  onChange={(e) => setSearchTerm(e.target.value)}
/>
</div>
            </div>
            {/* Render student list here */}
       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}

            <div className='table-responsive mt-3'>
<table className='w-100'>

<thead className='account-thead'>
    <th className='rounded-start-4'></th>
    <th>Roll No</th>
    <th>Reg No</th>
    <th>Name</th>
    <th>Father Name</th>  
    <th>DOB</th>
    <th>Class(Section)</th>
    <th>Gender</th>
        <th>Mobile No</th>
    <th className='rounded-end-4'>Activity</th>
</thead>


            {std.length === 0 ? (
              <tr className='text-center account-tr'><td colSpan={8}>No Student Data found</td></tr>
            ) : (
              <>
                {filteredStd.map((student) => (
  <tr className='account-tr' key={student.id}>
    <td className='rounded-start-4'>
      {student.is_promoted == 0 ? 
 <input
  type="checkbox"
checked={selectedStudents.some((s) => s.id === student.id)}
  onChange={() => handleStudentSelect(student)}
/> : <span className='text-success fw-bold'>P</span>}
</td>
    <td>{student.roll_no}</td>
    <td>{student.reg_no}</td>
    <td>{student.name}</td>
    <td>{student.father || '--'}</td>
    <td>{student.dob || '--'}</td>
<td>{student.class_name}({student.section})</td>
<td>{student.gender || '--'}</td>
<td>{student.mobile}</td>
<td>        <HiSearch className='emp-icon bg-purple' title='View' onClick={() => handleShowView(student)} />
        <FaUserEdit className='emp-icon bg-primary mx-2' title='Edit' onClick={() => navigate('/admin/edit-student', {state: {student}})} />
        {/* <MdDelete className='emp-icon bg-pink' title='Remove' onClick={() => handleShowDelete(student)}  /> */}
</td>
                    </tr>
                ))}
              </>
            )}

</table>
</div>
{/* table ends */}

<div className='text-center mt-3'>
<button
  className="profile-btn"
  disabled={selectedStudents.length === 0}
  onClick={() => setShowPromote(true)}
>
  Promote Student ({selectedStudents.length})
</button>
</div>


          </div>
        </div>
      </section>


      {showDelete && (
  <>
        <section className='ins-dialog'>
          <div className='ins-dialog-inner col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <p className='ins-dialog-heading text-danger'>Remove Student!</p>

<div className='table-responsive'>
<table className='w-100'>

<thead className='account-thead'>
    <th className='rounded-start-4'>Reg No</th>
    <th>Name</th>
    <th>Father Name</th>
    <th>DOB</th>
    <th>Class(Section)</th>
    <th>Gender</th>
        <th>Mobile No</th>
</thead>

<tr className='account-tr'>
    <td>{selectedStd.reg_no}</td>
    <td>{selectedStd.name}</td>
    <td>{selectedStd.father || '--'}</td>
    <td>{selectedStd.dob || '--'}</td>
<td>{selectedStd.class_name}({selectedStd.section})</td>
<td>{selectedStd.gender || '--'}</td>
<td>{selectedStd.mobile}</td>
</tr>


</table>
</div>

<p className='para-text mt-3'>Note: This action cannot be undone. Once deleted, the Student Record will be permanently removed.</p>

            <button className='profile-btn me-2' onClick={() => handleDelete(selectedStd.id)}>Remove Student</button>
            <button className='profile-btn2' onClick={() => setShowDelete(false)}>Go Back</button>


    </div>
  </section>
  </>
)}


{showStd && (
<>
        <section className='ins-dialog'>
          <div className='col-lg-10 col-12 animate__animated animate__fadeInDown mx-auto' onClick={(e) => e.stopPropagation()}>

            <button className='profile-btn2' onClick={() => setShowStd(false)}>Go Back</button>


<div className='row mt-2'>

<div className='col-lg-4 col-md-5 col-12 my-2'>
    <div className='profile-card'>
<div className='text-center'>
<img
src={
    selectedStd.profile_pic && selectedStd.profile_pic.trim() !== ''
      ? `https://api.kcian.in/inUploads/${selectedStd.profile_pic}`
      : UserLogo
  } className='emp-img' alt={selectedStd.name} />

<p className='emp-name2'>{selectedStd.name}</p></div>

<div className='bg-light px-3 py-3 rounded-4'>
<span className='profile-text'>Registration No</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedStd.reg_no}</span><br />

<span className='profile-text'>Admission No</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedStd.admission_no}</span><br />

<span className='profile-text'>Roll No</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedStd.roll_no}</span><br />

<span className='profile-text'>Class (Section)</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedStd.class_name} ({selectedStd.section})</span><br />

<span className='profile-text'>Mobile</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedStd.mobile}</span><br />

<span className='profile-text'>Email</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedStd.email || '-'}</span><br />

<span className='profile-text'>Date of Admission</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedStd.doa}</span><br />

<span className='profile-text'>Religion</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedStd.religion || '-'}</span><br />

<span className='profile-text'>Nationality</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedStd.nationality || '-'}</span><br />

</div>
{/* <span className='profile-text'>Email</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedStd.email || 'NA'}</span><br /> */}

<div className='px-3 py-3'>
<span className='profile-text'>DOB</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedStd.dob || '-'}</span><br />

<span className='profile-text'>Father Name</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedStd.father || '-'}</span><br />

<span className='profile-text'>Father's Mobile No</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedStd.f_mobile || '-'}</span><br />

<span className='profile-text'>Father's Occupation</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedStd.f_occupation || '-'}</span><br />

<span className='profile-text'>Mother Name</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedStd.mother || '-'}</span><br />

<span className='profile-text'>Mother's Mobile No</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedStd.m_mobile || '-'}</span><br />

<span className='profile-text'>Mother's Occupation</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedStd.m_occupation || '-'}</span><br />

<span className='profile-text'>Address</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedStd.address || '-'}</span><br />

<span className='profile-text'>Gender</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedStd.gender || '-'}</span><br />

<span className='profile-text'>Blood Group</span><br />
<span className='profile-text border-0'><i class="fa-solid fa-arrow-turn-up fa-rotate-90"></i> {selectedStd.blood_grp || '-'}</span><br />


</div>

</div>
</div>
{/* left ends */}

<div className='col-lg-8 col-md-7 col-12 my-2'>
<p className='emp-name2'><Bs1CircleFill /> Attendance Report</p>
<div className='profile-card'>

<div className='row text-light' onClick={() => navigate('/admin/students-attendance-report')}>

<div className='col-lg-4 col-md-6 col-sm-4 col-12 my-2'>
<div className='bg-primary px-3 py-3 rounded-4 d-flex justify-content-between'>
    <div>
    <p className='fw-bold text-uppercase para-text'>Presents</p>
    <span className='profile-badge2'>This Month</span></div>
<p>{attendanceSummary.present}</p></div>
</div>

<div className='col-lg-4 col-md-6 col-sm-4 col-12 my-2'>
<div className='bg-purple px-3 py-3 rounded-4 d-flex justify-content-between'>
    <div>
    <p className='fw-bold text-uppercase para-text'>Leaves</p>
    <span className='profile-badge2'>This Month</span></div>
<p>{attendanceSummary.leave}</p>
</div>    
</div>

<div className='col-lg-4 col-md-6 col-sm-4 col-12 my-2'>
<div className='bg-pink px-3 py-3 rounded-4 d-flex justify-content-between'>
    <div>
    <p className='fw-bold text-uppercase para-text'>Absents</p>
    <span className='profile-badge2'>This Month</span></div>
<p>{attendanceSummary.absent}</p></div>    
</div>

</div>
{/* inner row ends */}
</div>
{/* right sec1 ends  */}
 
<p className='emp-name2 mt-3'><Bs2CircleFill /> Fee Structure</p>
<div className='profile-card'>

            {/* <div className='mb-4 col-md-4'>
              <div className='profile-input-area'>
                <label className='profile-badge'>Current Month Fee</label>
                <p className='profile-input my-0'>Month Name</p>
              </div>
            </div> */}


              <div className='table-responsive mt-4'>
                <table className='w-100 text-center'>
                  <thead className='account-thead'>
                    <tr>
                      <th className='border'>S No</th>
                      <th className='border'>Class</th>
                      <th className='border' colSpan={3}>Fee List</th>
                      {/* <th className='border'>Added On</th> */}
                      <th className='border'>Collect Dues After</th>
                      <th className='border'>Due Fine</th>
                      <th className='border'>Annual Year</th>
                      <th className='border'>Structure Type</th>
                      {/* <th className='border'>Activity</th> */}
</tr>

<tr className='border-top'>
    <th colSpan={2}></th>
    <th className='border'>Fee Name</th>
    <th className='border'>Fee Type</th>
    <th className='border'>Amount (₹)</th>
    <th></th>
    <th className='border'>(Days)</th>
    <th className='border'>(₹)</th>
    <th className='border'>(A Y)</th>
    {/* <th colSpan={1}></th> */}
    </tr>
</thead>

                  <tbody>
                     {feeStr.length > 0 ? (
                    feeStr.map((feeS, index) => {
                      const feeListArr = JSON.parse(feeS.fee_list);
                      return (
<tr className='account-tr'>
<td className='border'>{index + 1}</td>
<td className='border'>{JSON.parse(feeS.class_id).className}</td>
<td colSpan={3} className='border'>
    {feeListArr.map((fee, index) => (
      <>
      <tr>
      <td>{fee.feePartName}</td>
      <td>{fee.feePartType}</td>
      <td>{fee.amount}</td>
      </tr>
</>    ))}
</td>
{/* <td className='border'>{formatDateTime(feeS.added_on)}</td> */}
<td className='border'>{feeS.due_days}</td>
<td className='border'>{feeS.due_fine}</td>
<td className='border'>{feeS.annual_year}</td>
<td className='border'>{feeS.structure_type}</td>
{/* <td className='border'><RiDeleteBin6Line className='account-icon1' title='Delete' onClick={() => handleShowDelete(feeS)} /></td> */}
</tr>
                    )
                    })): 
                    (
                      <tr className='account-tr'>
      <td className='py-3' colSpan={11}>
        No Fee Structure Created yet.
      </td>
    </tr>
                    )}
                  </tbody>
                </table>
              </div>

{/* 
<div className='text-center'>
    <img src={NoDataFound} className='no-data-found' />
</div> */}


</div>
    
</div>
{/* right ends */}


</div>
{/* row ends */}

</div>
</section>

</>
)}

{showPromote && (
  <section className='ins-dialog'>
          <div className='profile-card col-lg-11 col-12 animate__animated animate__fadeInDown ms-auto' onClick={(e) => e.stopPropagation()}>
       {response2.message && <ResponseMsg2 message={response2.message} status={response2.status} />}
      <h5 className='mb-4'>Promote Students from {selectedAY}</h5>

<div className='row'>
  <div className='col-md-4'>
   <div className='profile-input-area'>
                  <label className="profile-badge">Select AY*</label>
                  <select
                    className="profile-input"
                    value={promoteAY}
                    onChange={(e) => setPromoteAY(e.target.value)}
                    required
                  >
                    <option value="">-- Select Academic Year --</option>
                    {academicYears.map((ay) => (
                      <option key={ay.year} value={ay.year}>
                        {ay.year} --- {ay.title}
                      </option>
                    ))}
                  </select>
                </div></div>

  <div className='col-md-4'>

      <div className='profile-input-area'>
                  <label className="profile-badge">Select Class*</label>

        <select
          className='profile-input'
          value={promoteClassId}
          onChange={(e) => setPromoteClassId(e.target.value)}
          required
        >
          <option value=''>Select Class</option>
          {classes.map((cls) => (
            <option key={cls.id} value={cls.id}>
              {cls.class_name}
            </option>
          ))}
        </select>
      </div>
      </div>


  <div className='col-md-4'>
      <div className='profile-input-area'>
                  <label className="profile-badge">Select Section*</label>
        <select
          className='profile-input'
          value={promoteSection}
          onChange={(e) => setPromoteSection(e.target.value)}
        >
          <option value=''>Select Section</option>

          {classes
            .find(c => c.id === Number(promoteClassId))
            ?.sections?.split(',')
            .map(sec => (
              <option key={sec.trim()} value={sec.trim()}>
                {sec.trim()}
              </option>
            ))}
        </select>
      </div>
</div>

</div>



            <div className='table-responsive mt-3'>
<table className='w-100'>

<thead className='account-thead'>
    <th className='rounded-start-4'>Roll No</th>
    <th>Reg No</th>
    <th>Name</th>
    <th>Father Name</th>  
    <th>DOB</th>
    <th>Class(Section)</th>
    <th>Gender</th>
        <th className='rounded-end-4'>Mobile No</th>
</thead>

                {selectedStudents.map((student) => (
  <tr className='account-tr' key={student.id}>
    <td>{student.roll_no}</td>
    <td>{student.reg_no}</td>
    <td>{student.name}</td>
    <td>{student.father || '--'}</td>
    <td>{student.dob || '--'}</td>
<td>{student.class_name}({student.section})</td>
<td>{student.gender || '--'}</td>
<td>{student.mobile}</td>


</tr>
                ))}

</table>
</div>



      <div className='text-end mt-3'>
        <button
          className='profile-btn2 me-2'
          onClick={() => setShowPromote(false)}
        >
          Cancel
        </button>

        <button
          className='profile-btn'
          onClick={handlePromoteStudents}
        >
          Yes Promote
        </button>
      </div>
    </div>
  </section>
)}

    </>
  );
};

export default AllStudents;
